<ng-container *transloco="let t">
  @if ({ activeLang: activeLang$ | async }; as data) {
    <div class="form-group question-container-inner">
      <lib-input-container
        [headLine]="
          showOrHideInformationValue === '0' ||
          showOrHideInformationValue === '2'
            ? (question.translations?.list['headLine']
              | translate: data.activeLang : question.structure.headLine)
            : ''
        "
        [required]="true"
        [hideAbove]="true"
        [hideBelow]="true"
      >
        @if (showOrHideInformationValue === '0') {
          <div
            class="question-information"
            [innerHtml]="
              question.translations?.list['description']
                | translate: data.activeLang : question.structure.description
                | safeHtml
            "
          ></div>
        }
        @if (showOrHideInformationValue === '1') {
          <div
            [libCollapse]="isCollapsed"
            [attr.id]="'infoAccordion-' + question.id"
            class="question-information"
            [innerHtml]="
              question.translations?.list['description']
                | translate: data.activeLang : textContent
                | safeHtml
            "
          ></div>
          <ng-container
            *ngTemplateOutlet="
              linkButton;
              context: {
                buttonTexts: {
                  buttonText1: t('information_showMore_about', {
                    title:
                      (question.translations?.list['headLine']
                      | translate
                        : data.activeLang
                        : question.structure.headLine),
                  }),
                  buttonText2: t('information_showLess_about', {
                    title:
                      (question.translations?.list['headLine']
                      | translate
                        : data.activeLang
                        : question.structure.headLine),
                  }),
                },
              }
            "
          ></ng-container>
        }
        @if (showOrHideInformationValue === '2') {
          <div class="question-information" #infoContainer>
            <div
              [attr.id]="'infoAccordion-' + question.id"
              [innerHtml]="
                question.translations?.list['description']
                  | translate: data.activeLang : textContent
                  | safeHtml
              "
            ></div>
          </div>
          <ng-container
            *ngTemplateOutlet="
              linkButton;
              context: {
                buttonTexts: {
                  buttonText1: t('information_showMore'),
                  buttonText2: t('information_showLess'),
                },
              }
            "
          ></ng-container>
        }
      </lib-input-container>
    </div>
    <!-- Template -->
    <ng-template #linkButton let-buttonTexts="buttonTexts">
      <button
        vinnova-button-link
        type="button"
        size="small"
        (click)="showOrHideQuestion()"
        [attr.aria-expanded]="!isCollapsed"
        [attr.aria-controls]="'infoAccordion-' + question.id"
      >
        @if (isCollapsed) {
          <span
            >{{ buttonTexts.buttonText1 }}
            <lib-icon
              class="icon-chevron"
              name="chevron-down"
              aria-hidden="true"
            ></lib-icon
          ></span>
        }
        @if (!isCollapsed) {
          <span
            >{{ buttonTexts.buttonText2 }}
            <lib-icon
              class="icon-chevron"
              name="chevron-up"
              aria-hidden="true"
            ></lib-icon
          ></span>
        }
      </button>
    </ng-template>
  }
</ng-container>
